const checkIfElementIsVisible = function(element) {
	return element.offsetHeight > 0;
};

module.exports = checkIfElementIsVisible;
